import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { SharedService } from './services/shared.service';

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { tokenInterceptor } from './interceptors/token-interceptor.interceptor';
import { errorHandingInterceptor } from './interceptors/error-handing.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [SharedService],
      useFactory: (shared: SharedService) => () => shared.default_database_connection
    },
    provideHttpClient(
      withInterceptors([errorHandingInterceptor, tokenInterceptor])
    ),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    })
  ],
};
